export enum Common {
  modalName,
  save,
  back,
  edit,
  supportFeedback,
  logout,
  serviceName,
  devPortalName,
  from,
  notice,
  noApiKey,
}

export enum Validation {
  mandatoryPhoneNumber,
  mandatoryFirstName,
  mandatoryLastName,
  mandatoryEmail,
  mandatoryCompanyName,
  mandatoryStreet,
  mandatoryHouseNumber,
  mandatoryZipCode,
  mandatoryCity,
  mandatoryUrl,
  incorrectEmailPattern,
  incorrectUrlPattern,
}

export enum PlaceHolder {
  city,
  companyName,
  email,
  fistName,
  houseNumber,
  lastName,
  phoneNumber,
  street,
  url,
  zipCode,
}

export enum Operation {
  userContactUpdateSuccess = 'userContactUpdateSuccess',
  userCompanyUpdateSuccess = 'userCompanyUpdateSuccess',
  userCompanyCreateSuccess = 'userCompanyCreateSuccess',
}

export enum HTTPError {
  default = 'httpError_default',
  head = 'httpError_head',
  unauthorised = 'httpError_unauthorised',
}

export enum HTTPSuccess {
  head = 'httpSuccess_head',
  updated = 'httpSuccess_updated',
  saved = 'httpSuccess_saved',
}
